'use client'
import * as React from 'react'
import { AnimatePresence, LazyMotion, domAnimation, m } from 'framer-motion'
import { tw } from 'utils/classnames'
import { capitaliseFirstLetter } from 'utils/string'

import * as Modal from '@web/components/modal'
import { ErrorIcon } from '@web/components/icons/error'

interface RatingModalValidationProps extends Modal.ModalProps {
  children?: React.ReactNode
  error?: string | null
}

export function ModalWithError({ error, children, ...props }: RatingModalValidationProps) {
  return (
    <LazyMotion features={domAnimation}>
      <Modal.Modal {...props}>
        <Modal.Title>
          <AnimatePresence>
            {error ? (
              <m.div
                exit={{
                  height: 0,
                  opacity: 0,
                }}
                initial={{
                  height: 0,
                  opacity: 0,
                }}
                animate={{
                  height: 'auto',
                  opacity: 1,
                }}
                className="text-cf-white text-16 w-full shrink-0 overflow-hidden rounded-t-[24px] bg-[#E21743] px-8 py-3"
              >
                <p
                  className={tw(
                    'text-14 text-service-white items-center justify-center gap-3 p-2 text-left',
                    'flex',
                  )}
                >
                  <ErrorIcon className="shrink-0 text-[#FFDA70]" />
                  {capitaliseFirstLetter(error)}
                </p>
              </m.div>
            ) : null}
          </AnimatePresence>
        </Modal.Title>
        <Modal.Content>{children}</Modal.Content>
      </Modal.Modal>
    </LazyMotion>
  )
}
